import { useInCreateDialog } from 'components/create-dialog/CreateDialogContext';
import { CreateDialogRequiredBlock } from 'components/create-dialog/CreateDialogRequired';
import RadioInput from 'components/forms/inputs/rhf-inputs/RadioInput';
import { t } from 'utils/getTranslations';
import { ContactFormState } from './useContactForm';

const PARTY_TYPES = [
    { value: 'COMPANY', label: t('contacts.types.company') },
    { value: 'PERSON', label: t('contacts.types.person') },
];

/** Choose type: company or person; changing it on an existing contact converts the contact at once. */
export const ChooseTypeFields = ({ form }: { form: ContactFormState }): JSX.Element => {
    const { control, setValue } = form.methods;
    const { hasUpdateContactTypePermission, type } = form;
    const inCreateDialog = useInCreateDialog();

    // RadioInput always validates as required, but this one is not marked so (no `required`), and the create
    // dialog moves only a marked field into Required by itself.
    return (
        <CreateDialogRequiredBlock when>
            <RadioInput
                setValue={setValue}
                control={control}
                label="contacts.type"
                name="partyType"
                options={PARTY_TYPES}
                getOptionLabel="label"
                getOptionIdentifier="value"
                readonly={type === 'edit' && !hasUpdateContactTypePermission}
                // One line in the create dialog, where it shares its row with the relationship type. Left unset
                // anywhere else: a record section lays the options on one line by itself, and a `false` here
                // would stack them there.
                row={inCreateDialog || undefined}
            />
        </CreateDialogRequiredBlock>
    );
};
